import { useState, useMemo, useEffect, forwardRef } from "react";
import PropTypes from "prop-types";
import { useIntl } from "react-intl";
import { useColumnOrder, useExpanded, useSortBy, useTable } from "react-table";

import "../../shipper/Quotes/Quotes.scss";
import Card from "components/molecules/Card/Card";
import DataTable from "components/organisms/DataTable/DataTable";
import SubQuote from "pages/shipper/ShipmentQuotes/components/quotes/SubQuote";
import getQuotationDetailListColumn from "./QuotationDetailListColumn";
import { IGoodItem } from "./QuotationType";

interface IQuotationListProps {
  quoteDetailData: any;
}

const QuotationDetailTable = forwardRef<HTMLDivElement, IQuotationListProps>(({ quoteDetailData }, ref) => {
  const [data, setData] = useState<IGoodItem[]>([]);
  const intl = useIntl();
  const { good_items } = quoteDetailData?.organization || {};
  const columns = useMemo(() => getQuotationDetailListColumn(intl), []);

  const instance = useTable<any>(
    {
      columns,
      data,
      SubQuote,
    },
    useSortBy,
    useColumnOrder,
    useExpanded,
  );

  const fallbackMessage = "No quotation detail found.";

  useEffect(() => {
    if (good_items?.length) {
      setData([]);
      setData(good_items);
    }
  }, []);

  return (
    <div ref={ref}>
      <Card cardStyle={{ borderRadius: "16px", cursor: "default !important" }} className="quotes-container">
        <DataTable customNoResults={fallbackMessage} tableInstance={instance} />
      </Card>
    </div>
  );
});

QuotationDetailTable.propTypes = {
  quoteDetailData: PropTypes.instanceOf(Object),
};

QuotationDetailTable.defaultProps = {
  quoteDetailData: undefined,
};

export default QuotationDetailTable;
